import React, { FC } from 'react';
import './Dashboard.scss';
import DashboardMap from './DashboardMap/DashboardMap';

const Dashboard: FC = (): React.ReactElement => {
    document.title = 'Dashboard';
    return (
        <div>
            <DashboardMap />
        </div>
    );
};

export default Dashboard;

